"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = exports.useAutoGrowingTextarea = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = (0, tslib_1.__importStar)(require("react"));
const lib_1 = require("../../lib");
function useAutoGrowingTextarea(ref, value, enabled = true) {
    react_1.default.useEffect(() => {
        if (ref.current && enabled) {
            ref.current.style.height = `${ref.current.scrollHeight}px`;
        }
    }, [value, enabled]);
}
exports.useAutoGrowingTextarea = useAutoGrowingTextarea;
/**
 * Textarea component
 *
 * @visibleName Textarea
 */
const Textarea = (props) => {
    const { size = "2", value, placeholder, className, required, onBlur, onFocus, onChange, autoFocus, onKeyDown, onKeyPress, readOnly, onClick, innerRef, autoGrow, style = {}, } = props;
    const textAreaRef = (0, react_1.useRef)(null);
    useAutoGrowingTextarea(textAreaRef, value, autoGrow);
    (0, react_1.useEffect)(() => {
        if (innerRef) {
            innerRef.current = textAreaRef.current;
        }
    }, [innerRef]);
    const handleChange = (0, react_1.useCallback)((event) => {
        if (onChange) {
            onChange(event.target.value, event);
        }
    }, [onChange]);
    const handleBlur = (0, react_1.useCallback)((event) => {
        if (onBlur) {
            onBlur(event.target.value, event);
        }
    }, [onBlur]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)((0, lib_1.bem)("input-group", (0, lib_1.use)(required, "--is-required")), className) }, { children: (0, jsx_runtime_1.jsx)("textarea", { autoFocus: autoFocus, readOnly: readOnly, className: (0, lib_1.bem)("input-group__textarea", (0, lib_1.use)(size, () => `--${size.replace(".", "_")}`), (0, lib_1.use)(autoGrow, "--auto-grow")), placeholder: placeholder, value: value || "", onChange: handleChange, onBlur: handleBlur, onFocus: onFocus, onKeyDown: onKeyDown, onKeyPress: onKeyPress, onClick: onClick, ref: textAreaRef, style: Object.assign(Object.assign({}, style), { resize: autoGrow || readOnly ? "none" : "auto" }) }, void 0) }), void 0));
};
exports.Textarea = Textarea;
//# sourceMappingURL=Textarea.js.map